import * as React from 'react';
import { RadioIndicator } from '@leagueplatform/genesis-core';
import { EntityDetail } from '@web-config-app/core';
import { TableCell } from '../table-pieces.component';

export type RadioIndicatorCellProps = {
  item: EntityDetail;
  disabled?: boolean;
  onChange?: () => void;
};

export const RadioIndicatorCell = ({
  item,
  disabled,
  onChange,
}: RadioIndicatorCellProps) => (
  <TableCell css={{ paddingY: '$threeQuarters' }}>
    <RadioIndicator
      id={`entity-${item.id}`}
      name="entity-select"
      disabled={disabled}
      onChange={() => {
        onChange?.();
      }}
    />
  </TableCell>
);
